// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormTextarea_wrapper__2_kut","textarea":"FormTextarea_textarea__2SkVi"};